// extracted by mini-css-extract-plugin
export default {"zoomModal":"t2-z","image":"u2-z","button":"v2-z","isOverlayShown":"w2-z"};